import { formatToolkitListingID } from '@aloft/toolkit-shared';

import { TOOLKIT_REFERENCE_VIEW_PROPERTY_ID_PREFIX } from './consts.ts';
import { ReferenceViewID, ReferenceViewIDParsed } from './types.ts';

export function formatReferenceViewID(id: ReferenceViewIDParsed): ReferenceViewID {
  if ('type' in id) {
    const prefix = `${TOOLKIT_REFERENCE_VIEW_PROPERTY_ID_PREFIX}${id.type}`;
    if (id.type === 'subject') {
      return prefix as ReferenceViewID;
    }
    return `${prefix}:${id.compID}` as ReferenceViewID;
  }
  return formatToolkitListingID(id);
}
